<template>
  <div style="position:relative;">
    <load-overlay v-if="loading" style="position:absolute;min-height:100pt;" />

    <md-table v-else v-model="searchRes" :md-sort.sync="vm.sortBy" :md-sort-order.sync="vm.sortOrder" :md-sort-fn="vm.sortFunc" md-card :md-fixed-header="false /* re-add when fixed in vuematerial */">
      <md-table-toolbar>
        <div class="md-toolbar-section-start">
          <div>
            <h1 class="md-title">{{ vm.name }}</h1>
          </div>

          <md-field v-if="!hideYearFilter" style="width:70pt;margin-left:15pt;">
            <md-select v-model="year" md-dense>
              <md-option v-for="y in years" :value="y" :key="y">{{ y }}</md-option>
            </md-select>
          </md-field>
        </div>
        
        <div class="md-toolbar-section-end">
          <md-field md-clearable>
            <md-input v-model="search" @input="doSearch" placeholder="Zoeken..." />
          </md-field>

          <md-button class="md-icon-button md-raised md-primary" @click="load(0)">
            <md-icon>refresh</md-icon>
          </md-button>
        </div>
      </md-table-toolbar>

      <md-table-row slot="md-table-row" slot-scope="{ item }" @click="vm.onClickFunc(item)">
        <md-table-cell v-for="col in vm.columns" :key="col.name" :md-label="col.name" :md-sort-by="col.sort" :style="col.style ? col.style : ''">{{ col.select(item) }}</md-table-cell>
      </md-table-row>

      <md-table-empty-state md-icon="search" md-label="Geen items" :md-description="`Geen ${vm.name.toLowerCase()} gevonden${(year != null ? ` in ${year}` : '')}.`" />
    </md-table>
  </div>
</template>

<script>
  import { Events } from '@wsb/wsb-jsbase';
  import LoadOv from '@/components/LoadOverlay';

  const _comp = {
    name: 'listview',
    props: {
      vm: Object,
      ["hide-year-filter"]: {
        type: Boolean,
        default: false
      }
    },
    data: () => ({
      loading: true,
      items: [],
      searchRes: [],
      search: '',
      year: null,
      years: Array.from(new Array((new Date()).getYear() - 116 + 2), (x, i) => 2016 + i)
    }),
    methods: {
      load(cacheMaxAgeSec = 300) {
        this.loading = true;
        this.items = [];
        this.search = '';
        this.vm.getFunc(this, cacheMaxAgeSec)
          .then(res => {
            this.res = this.vm.sortFunc(res); // Apply sort manually on first load (Otherwise list is not sorted, seems to be a vuematerial issue)
            this.items = res;
            this.doSearch();
            this.loading = false;
          })
          .catch(e => {
            this.loading = false;
            Events.RaiseExceptionOccurred(e);
          });
      },
      doSearch() {
        if (this.search != '') {
          var srch = this.search;
          setTimeout(() => {
            if (this.search == srch) {
              this.searchRes = this.vm.searchFunc(srch, this.items);
            }
          }, 500);
        } else {
          this.searchRes = this.items;
        }
      }
    },
    created() {
      this.loading = true;
      if (!this.hideYearFilter) {
        var yr = localStorage.getItem(`${this.vm.name}Year`);
        yr = yr !== null ? yr : new Date().getFullYear();
        this.year = this.years.find(y => y == yr);
      }
      this.load();
    },
    watch: {
      year: function (newVal, oldVal) {
        localStorage.setItem(`${this.vm.name}Year`, newVal);
        if (oldVal != null) {
          this.load();
        }
      }
    },
    components: {
      'load-overlay': LoadOv
    }
  };

  export default _comp;
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/base/Listview.vue